import React, { useEffect, useState } from "react";
import RateTable from "./RateTable";
import Grid from "@material-ui/core/Grid";
import Button from "../Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import { Checkbox, FormControl, FormControlLabel, FormGroup, InputAdornment, MenuItem } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import moment from "moment";
import { KeyboardDatePicker } from "@material-ui/pickers";
import StatusOverlay from "../StatusOverlay";

const CreateMode = ({ openDialog, setOpenDialog, rateClasses, rateTypes, zones, tdsps, doCreateTDSPRate, user_id }) => {
    const time = moment.tz();
    const localtz = moment.tz.guess();
    const date = time.clone().tz(localtz);
    const startDate = moment(date).format("YYYY-MM-DD")
    const [selectedDate, setSelectedDate] = useState(startDate);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [endDateNull, setEndDateNull] = useState(false)
    const [keepButtonDisabled, setKeepButtonDisabled] = useState(true)
    const [newRateRequest, setNewRateRequest] = useState({
        tdsp_id: 0,
        rate_type_id: 0,
        class_type_id: 0,
        zone_id: 0,
        rate: 0.0,
        start_date: `${moment(selectedDate).format("YYYY-MM-DD")}`,
        end_date: endDateNull ? null : `${moment(selectedEndDate).format("YYYY-MM-DD")}`,
        user_id: user_id,
        status: "actual"
    })
    const [tdspSelected, setTDSPSelected] = useState(false)
    const [rateTypeSelected, setRateTypeSelected] = useState(false)
    const [stateCode, setStateCode] = useState("")
    const statuses = ['actual', 'proposed', 'forecasted']

    const handleTDSPChange = (event) => {
        setNewRateRequest(prevState => ({
            ...prevState,
            tdsp_id: parseInt(event.target.value, 10),
            rate_type_id: 0,
            rate: 0.0
        }));

        const state_code = tdsps.filter(item => item.ID === event.target.value)[0].state_code

        setStateCode(state_code)
        if (rateTypeSelected) {
            setRateTypeSelected(false)
        }
        setTDSPSelected(true)
    }

    const handleTDSPRateTypeChange = (event) => {

        const rate_id = parseInt(event.target.value, 10)
        let rate = 0

        if (rateTypeSelected && rate_id !== 2 && newRateRequest.rate > 0.99) {
            rate = 0.99
        }

        if (rateTypeSelected && rate_id !== 2 && newRateRequest.rate < 0.01) {
            rate = 0.01
        }

        if (rate !== 0) {
            setNewRateRequest(prevState => ({
                ...prevState,
                rate_type_id: rate_id,
                rate: rate
            }));
        } else {
            setNewRateRequest(prevState => ({
                ...prevState,
                rate_type_id: rate_id
            }));
        }

        setRateTypeSelected(true)
    }

    const handleTDSPStatusChange = (event) => {
        setNewRateRequest(prevState => ({
            ...prevState,
            status: event.target.value
        }));
    }

    const handleTDSPRateClassChange = (event) => {
        setNewRateRequest(prevState => ({
            ...prevState,
            class_type_id: parseInt(event.target.value, 10)
        }));
    }

    const handleTDSPZoneChange = (event) => {
        setNewRateRequest(prevState => ({
            ...prevState,
            zone_id: parseInt(event.target.value, 10)
        }));
    }

    const handleTDSPRateChange = (event) => {

        let value = parseFloat(event.target.value) || ""

        if (parseFloat(event.target.value) === 0) {
            value = 0
        }

        if ((value < 0 || value > 0.99) && newRateRequest.rate_type_id !== 2 && newRateRequest.rate_type_id !== 7) {
            return
        }

        setNewRateRequest(prevState => ({
            ...prevState,
            rate: value
        }));
    }

    const handleEndDateNullClick = (event) => {
        setKeepButtonDisabled(!event.target.checked)
        setEndDateNull(event.target.checked)
    }

    const setCreateDisabled = newRateRequest.tdsp_id === 0 ||
        newRateRequest.rate_type_id === 0 ||
        newRateRequest.class_type_id === 0 ||
        (newRateRequest.rate <= 0.0 && newRateRequest.rate_type_id !== 7) ||
        newRateRequest.rate === "" ||
        isNaN(newRateRequest.rate) ||
        keepButtonDisabled === true ||
        (newRateRequest.rate < 0.01 && newRateRequest.rate_type_id !== 2 && newRateRequest.rate_type_id !== 7) ||
        (newRateRequest.rate > 0.99 && newRateRequest.rate_type_id !== 2);

    useEffect(() => {
        if (moment(selectedEndDate).isBefore(moment(selectedDate))) {
            setSelectedEndDate(selectedDate);
        }

        const isEndDateValid = selectedEndDate !== null && moment(selectedEndDate).isValid();

        if (!endDateNull && !isEndDateValid) {
            setKeepButtonDisabled(true);
        } else {
            setKeepButtonDisabled(false);
        }

        setNewRateRequest(prevState => ({
            ...prevState,
            start_date: moment(selectedDate).format("YYYY-MM-DD"),
            end_date: endDateNull ? null : moment(selectedEndDate).format("YYYY-MM-DD"),
        }));
    }, [selectedDate, selectedEndDate, endDateNull]);

    useEffect(() => {
        if (openDialog) {
            setSelectedDate(moment(date).format("YYYY-MM-DD"))
            setSelectedEndDate(null)
            setNewRateRequest(prevState => ({
                ...prevState,
                start_date: `${moment(selectedDate).format("YYYY-MM-DD")}`,
                end_date: null
            }));
        }
    }, [openDialog])

    return (
        <Dialog
            open={openDialog}
            ariaHideApp={false}
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle style={{ marginRight: '20px', marginLeft: '20px' }}>
                Create New Rate
            </DialogTitle>
            <DialogContent style={{ overflow: 'hidden' }}>
                <DialogContentText style={{ marginRight: '20px', marginLeft: '20px' }}>
                    <Grid container>
                        <Grid style={{ gap: '20px', display: 'flex', alignItems: 'center' }} item sm={12}>
                            <KeyboardDatePicker
                                label="Start Date*"
                                dateformat="YYYY-MM-DD"
                                value={moment(selectedDate).tz(localtz)}
                                minDate={moment("1900-01-01")}
                                onChange={() => null}
                                onAccept={(value) => {
                                    setSelectedDate(moment(value).format("YYYY-MM-DD"))
                                }
                                }
                                views={["year", "month", "date"]}
                                style={{ margin: "15px 0px", width: "200px" }}
                                disabled={!tdspSelected}
                            />
                            <KeyboardDatePicker
                                label="End Date*"
                                dateformat="YYYY-MM-DD"
                                value={selectedEndDate === null ? null : moment(selectedEndDate).tz(localtz)}
                                minDate={moment(selectedDate).tz(localtz)}
                                onChange={() => null}
                                onAccept={(value) => {
                                    setSelectedEndDate(moment(value).format("YYYY-MM-DD"))
                                }
                                }
                                views={["year", "month", "date"]}
                                style={{ margin: "15px 0px", width: "200px" }}
                                disabled={!tdspSelected || endDateNull}
                            />
                            <FormGroup row style={{ marginTop: "30px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={endDateNull}
                                            onChange={handleEndDateNullClick}
                                            color="primary"
                                            disabled={!tdspSelected}
                                        />
                                    }
                                    label="No End Date"
                                />
                            </FormGroup>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label="TDSP*"
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    value={newRateRequest.tdsp_id || ''}
                                    select
                                    onChange={handleTDSPChange}
                                >
                                    {tdsps && tdsps.sort((a, b) => a.name.localeCompare(b.name)).map(item => <MenuItem key={item.ID} value={item.ID}>{item.name}</MenuItem>)}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label="Rate Type*"
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    select
                                    value={newRateRequest.rate_type_id || ''}
                                    onChange={handleTDSPRateTypeChange}
                                    disabled={!tdspSelected}
                                >
                                    {rateTypes && rateTypes.sort((a, b) => a.type.localeCompare(b.type)).filter(item => {
                                        if (!item.rate_type_eligibility) return true;

                                        return Array.isArray(item.rate_type_eligibility) && item.rate_type_eligibility.includes(stateCode)
                                    }).map(item => <MenuItem key={item.id} value={item.id}>{item.type}</MenuItem>)}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label="Status*"
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    defaultValue={statuses[0] || ''}
                                    select
                                    onChange={handleTDSPStatusChange}
                                    disabled={!tdspSelected}
                                >
                                    {statuses && statuses.sort().map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label="Rate Class*"
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    select
                                    value={newRateRequest.class_type_id || ''}
                                    onChange={handleTDSPRateClassChange}
                                    disabled={!tdspSelected}
                                >
                                    {rateClasses && rateClasses.sort((a, b) => a.type.localeCompare(b.type)).map(item => <MenuItem key={item.id} value={item.id}>{item.type}</MenuItem>)}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label="Rate Zone (Optional)"
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    select
                                    value={newRateRequest.zone_id || ''}
                                    onChange={handleTDSPZoneChange}
                                    disabled={!tdspSelected || (zones.filter(item => parseInt(item.tdsp_id, 10) === newRateRequest.tdsp_id).length === 0)}
                                >
                                    {zones && zones.sort((a, b) => a.zone.localeCompare(b.zone)).filter(item => parseInt(item.tdsp_id, 10) === newRateRequest.tdsp_id).map(item => <MenuItem key={item.id} value={item.id}>{item.zone}</MenuItem>)}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label="Rate*"
                                    type="number"
                                    size="small"
                                    value={newRateRequest.rate}
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{
                                        step: "0.0001",
                                        min: newRateRequest.rate_type_id === 7 ? null : newRateRequest.rate_type_id !== 2 ? "0.01" : "0",
                                        ...(newRateRequest.rate_type_id !== 2 && { max: "0.99" }),
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">$</InputAdornment>
                                    }}
                                    variant="outlined"
                                    onChange={handleTDSPRateChange}
                                    disabled={!tdspSelected || !rateTypeSelected}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ marginRight: '20px', marginLeft: '20px' }}>
                <Button
                    color="secondary"
                    variant="contained"
                    style={{
                        float: "right",
                        marginRight: 5,
                        marginBottom: 10,
                    }}
                    onClick={() => {
                        setTDSPSelected(false)
                        setRateTypeSelected(false)
                        setEndDateNull(false)
                        doCreateTDSPRate(newRateRequest, 0, 100)
                        setNewRateRequest({
                            tdsp_id: 0,
                            rate_type_id: 0,
                            class_type_id: 0,
                            zone_id: 0,
                            rate: 0.0,
                            start_date: "",
                            end_date: "",
                            user_id: user_id,
                            status: "actual"
                        });
                        setOpenDialog(false)
                    }}
                    disabled={setCreateDisabled}
                >
                    Create
                </Button>
                <Button
                    onClick={() => {
                        setTDSPSelected(false)
                        setRateTypeSelected(false)
                        setEndDateNull(false)
                        setNewRateRequest({
                            tdsp_id: 0,
                            rate_type_id: 0,
                            class_type_id: 0,
                            zone_id: 0,
                            rate: 0.0,
                            start_date: "",
                            end_date: "",
                            user_id: user_id,
                            status: "actual"
                        });
                        setOpenDialog(false)
                    }}
                    color="primary"
                    variant="contained"
                    style={{
                        float: "right",
                        marginRight: 20,
                        marginBottom: 10,
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const TDSP = (props) => {
    const [openCreateDialog, setOpenCreateDialog] = useState(false);
    const pageLimit = 100
    const pageNumber = 0

    useEffect(() => {
        props.doFetchTDSPRateClasses();
        props.doFetchTDSPRateTypes();
        props.doFetchTDSPZones();
        props.doFetchTDSP();
        props.doFetchTDSPRates(pageNumber, pageLimit);
    }, []);

    return (
        <div>
            <Grid container>
                <Grid item sm={6}>
                    <h4>TDSP Rates</h4>
                </Grid>
                <Grid item sm={6}>
                    <Button
                        color="secondary"
                        variant="contained"
                        onClick={() => setOpenCreateDialog(true)}
                        style={{ float: "right", margin: "24px 0 16px" }}
                    >
                        Create
                    </Button>
                </Grid>
            </Grid>

            <RateTable
                user_id={props.authData.userID}
                tdsp={props.tdsp}
                tdsps={props.tdsp_list}
                rateTypes={props.rate_types}
                rateClasses={props.rate_classes}
                zones={props.tdsp_zones}
                doCreateTDSPRate={props.doCreateTDSPRate}
                doEditTDSPRate={props.doEditTDSPRate}
            />

            <CreateMode
                openDialog={openCreateDialog}
                setOpenDialog={setOpenCreateDialog}
                rateClasses={props.rate_classes}
                rateTypes={props.rate_types}
                zones={props.tdsp_zones}
                tdsps={props.tdsp_list}
                doCreateTDSPRate={props.doCreateTDSPRate}
                user_id={props.authData.userID}
            />

            <StatusOverlay />
        </div>
    );

}

export default TDSP